export default function({
    settings = {},
    name,
    onChange
}) {

    return [
        {
            type: "Switch",
            data: {
                onChange,
                value: settings[name],
            }
        }
    ]
}